import React from 'react';
import { Img } from '../Img';
import { Wrapper } from './BgImage.styled';

export default function FeaturedImage({ src, alt, variant }) {
	return (
		<Wrapper $variant={variant}>
			<Img src={src} alt={alt} />
			<div className="overlay" />
		</Wrapper>
	);
}
